module.exports = __webpack_public_path__ + "img/popup-report-icon.b086ea9d.svg";